var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoGoogleSearchConsole = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 54,
    viewBox: "0 0 60 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8259 4.49954L21.2851 0V8.59103H16.8259V4.49954ZM43.1768 4.49954L38.7176 0V8.59103H43.1768V4.49954Z",
    fill: "#7B7B7B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2851 0H38.7176V4.29552H21.2851V0Z",
    fill: "#5A5A5A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.1364 53.9972H4.86361C2.17769 53.9972 0 51.7999 0 49.0897V17.0249L8.3583 8.59103H51.6417L60 17.0249V49.0897C60 51.7999 57.8223 53.9972 55.1364 53.9972Z",
    fill: "#E6E7E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 25.9771V17.0249L8.3583 8.59103H51.6417L60 17.0249V25.9771H0Z",
    fill: "#D0D1D2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.89102 19.2278C6.89102 18.0974 7.79817 17.1821 8.91844 17.1821H51.0816C52.2018 17.1821 53.109 18.0974 53.109 19.2278V54H6.89102V19.2278Z",
    fill: "#458CF5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89102 25.9771H53.109V54H6.89102V25.9771Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3242 53.9972V45.6102L35.2694 41.5187L32.6354 34.1546L34.4606 29.451L44.7999 39.8838L46.6251 32.1116L53.1117 38.6569V53.9972H39.3242Z",
    fill: "#D2D3D4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93215 29.2498H25.3372V46.6359H9.93215V29.2498ZM9.93215 50.5206H29.7964V53.9972H9.93215V50.5206Z",
    fill: "#D2D3D4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1768 47.474V54H34.6628V47.5678C29.6188 45.2518 27.3892 39.2469 29.6871 34.1574C30.6599 32.0013 32.3485 30.2589 34.4606 29.2305V38.8637L38.7176 41.5215L43.1768 38.8637V29.2305C48.1689 31.6622 50.2646 37.714 47.8574 42.7539C46.871 44.8134 45.2206 46.4787 43.1768 47.474Z",
    fill: "#505050"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6563 19.432C12.6072 19.432 13.3804 20.2095 13.3804 21.1717C13.3804 22.1339 12.6099 22.9114 11.6563 22.9114C10.7027 22.9114 9.93217 22.1339 9.93217 21.1717C9.93217 20.2095 10.7054 19.432 11.6563 19.432ZM16.7221 19.432C17.673 19.432 18.4462 20.2095 18.4462 21.1717C18.4462 22.1339 17.6757 22.9114 16.7221 22.9114C15.7685 22.9114 14.998 22.1339 14.998 21.1717C14.998 20.2095 15.7712 19.432 16.7221 19.432Z",
    fill: "#E6E7E8"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoGoogleSearchConsole);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_google_search_console.72aeb36c80f5dd5328ef76561d28a084.svg";